<script lang="ts">
    import { translation } from "../../../../stores.js";
    import ButtonControl from "../../ButtonControl.svelte";
    import { faCameraRotate } from "@fortawesome/free-solid-svg-icons";
    import IconFa from "../../../Icon/IconFa.svelte";

    export let mode: "full" | "hangup-only" = "full";

    export let paused: boolean = false;
    export let muted: boolean = false;
    export let audioEnabled: boolean = true;
    export let torchOn: boolean = false;
    export let torchAvailable: boolean = false;
    export let showSwitchCamera: boolean = false;

    export let videoPauseOrigin: "self" | "conseiller" = "self";
    export let audioMuteOrigin: "self" | "conseiller" = "self";

    export let onPause: () => void = () => {};
    export let onResume: () => void = () => {};
    export let onMute: () => void = () => {};
    export let onUnmute: () => void = () => {};
    export let onTorch: () => void = () => {};
    export let onHangup: () => void = () => {};
    export let onSwitchCamera: () => void = () => {};

    $: canResume = videoPauseOrigin !== "conseiller";
    $: canUnmute = audioMuteOrigin !== "conseiller";
</script>

{#if mode === "full"}
    <ButtonControl
        btnClass={paused ? (canResume ? "green" : "gray") : "gray"}
        onClick={() => {
            if (paused && canResume) onResume();
            else if (!paused) onPause();
        }}
        icon={paused ? "fa fa-play" : "fa fa-pause"}
        title={paused
            ? canResume
                ? translation.camera.resumeButton
                : translation.alert.cameraPausedAdvisor
            : translation.camera.pauseButton}
        disabled={paused && !canResume}
    />

    {#if audioEnabled}
        <ButtonControl
            btnClass={muted ? "green" : "gray"}
            onClick={() => {
                if (muted && canUnmute) onUnmute();
                else if (!muted) onMute();
            }}
            icon={muted ? "fa fa-microphone-slash" : "fa fa-microphone"}
            title={muted
                ? canUnmute
                    ? translation.camera.resumeMicButton
                    : translation.alert.cameraMutedAdvisor
                : translation.camera.micButton}
            disabled={muted && !canUnmute}
        />
    {/if}

    {#if showSwitchCamera}
        <button class="btn green" on:click={onSwitchCamera}>
            <!-- <Icon name="fa fa-camera" /> -->
            <IconFa icon={faCameraRotate} />
        </button>
    {:else}
        <button class="btn gray" on:click={onSwitchCamera} disabled>
            <!-- <Icon name="fa fa-camera" /> -->
            <IconFa icon={faCameraRotate} />
        </button>
    {/if}

    {#if torchAvailable}
        <ButtonControl
            btnClass={torchOn ? "yellow" : "gray"}
            onClick={onTorch}
            icon="fa fa-lightbulb-o"
            title={torchOn ? "Torch" : "Torch"}
        />
    {/if}
{/if}

<ButtonControl
    btnClass="red"
    onClick={onHangup}
    icon="fa fa-stop"
    title="Hangup"
/>

<style>
    .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border-radius: 9999px;
        color: white;
        box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
        transition: all 0.15s ease;
    }

    .btn.gray {
        background: #4b5563;
    }
    .btn.gray:hover {
        background: #374151;
    }

    .btn.green {
        background: #16a34a;
    }
    .btn.green:hover {
        background: #15803d;
    }
</style>
